<kendo-grid-column [field]="field" [width]="width" [locked]="locked">
  <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
    <ng-container>
      <wlm-column-header-template [columnTitle]="column"></wlm-column-header-template>
    </ng-container>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem
    ><wlm-image-column-cell
      [dataItem]="dataItem"
      [imageElements]="imageElements"
      [field]="field"
    ></wlm-image-column-cell>
  </ng-template>

  <ng-template
    kendoGridFilterMenuTemplate
    let-filter
    let-column="column"
    let-filterService="filterService"
  >
    <wlm-image-column-filter
      [field]="column.field"
      [filterService]="filterService"
      [filter]="filter"
      [elements]="imageElements"
    ></wlm-image-column-filter>
  </ng-template>
</kendo-grid-column>
